import React from 'react';
import { Box, SecondaryButton, Title } from '@src/shared/ui';
import { getUrlIOSorAndroid } from '@src/shared/utils';
import { useGTM, useProposalState } from '@src/shared/hooks';
import { GTMEvents } from '@src/config/gtm';

export const FeedbackSidebar: React.FC = () => {
  const { trackEvent } = useGTM();
  const { proposal } = useProposalState();

  const onTrackEvent = () => {
    trackEvent(GTMEvents.DOWNLOAD_APP, {
      etapa: 'tela_erro',
      proposal_id: proposal.proposalId,
    });
  };

  return (
    <Box
      className={`
        col-span-4
        -mx-6
        w-auto

        sm:mx-0
        sm:mt-16
        sm:mb-20
        sm:col-span-4
        sm:col-end-9
        sm:row-start-1

        md:col-end-13

        lg:col-span-4
        lg:col-start-9
      `}
    >
      <Box
        className={`
        row-start-1
        col-span-4
        bg-secondary-40
        mb-0
        w-auto
        h-auto

        sm:mb-auto
        sm:col-span-4
        sm:rounded-xl
        sm:col-start-1
        sm:col-end-5

        md:col-end-13

        lg:col-start-9
      `}
      >
        <div
          className={`
          bg-[url('/PAGOL_FOTO_14.png')] 
          bg-center
          bg-cover
          h-[178px]

          min-[320px]:bg-[length:110%]
          min-[430px]:bg-[center_-30px]
          min-[600px]:bg-[center_-40px]
          
          sm:bg-cover
          sm:bg-center

          sm:rounded-t-xl
        `}
        />
        <Box
          className={`
          grid
          grid-cols-1
          col-span-4
          auto-rows-max
        `}
        >
          <Title
            className={`
            text-2xl
            leading-7
            font-semibold
            text-white
            mt-8
            sm:mt-6
            mx-6
          `}
          >
            Descubra os benefícios da Conta Digital para quem ama viajar!
          </Title>
          <Title
            className={`
            text-[16px]
            text-white
            text-base
            mt-3
            mx-6
          `}
          >
            Ganhe milhas em transações do dia a dia e troque por dinheiro no
            nosso app ou por outros produtos na Smiles.
          </Title>
          <Title
            fontSize='md'
            color='white'
            fontWeight='regular'
            lineHeight='shorter'
            className={`
            hidden
            m-0
            sm:flex
            sm:mt-3
            sm:mx-6
          `}
          >
            Baixe o App PaGol:
          </Title>
          <Box
            className={`
            flex-row
            mt-6
            mx-6
            mb-8
            hidden
            sm:flex
          `}
          >
            <Box
              className={`
              h-auto
              w-auto
              max-h-[106px]
              max-w-[106px]
              border-solid
              border-white
              border-[2px]
              rounded-[7px]
              p-2
              lg:p-3
              m-0
              text-white
              font-inter
              font-normal
              text-base
              hidden

              hover:border-[#C1D8EA]
              hover:text-[#C1D8EA]

              sm:flex
              sm:items-center
              sm:mr-2
              lg:mr-4
            `}
            >
              <img
                src='/qrcode.svg'
                alt='QR Code'
                className={`
                  sm:min-h-[60px]
                  sm:min-w-[60px]
                  lg:h-20
                  lg:w-20
                `}
              />
            </Box>
            <Box
              className={`
              flex
              flex-1
              sm:gap-2
              lg:gap-4
              flex-col
              min-w-[130px]
            `}
            >
              <SecondaryButton
                onClick={() => {
                  onTrackEvent();
                  window.location.href =
                    'https://play.google.com/store/apps/details?id=com.br.pagol&hl=pt';
                }}
                className={`
                flex-1
                h-[45px]
                w-auto
                m-0
                border-white
                rounded-[7px]
                justify-center
                align-center
                text-white
                font-inter
                font-normal
                text-base
                hidden

                hover:border-[#C1D8EA]
                hover:text-[#C1D8EA]

                sm:flex
                sm:justify-center
              `}
              >
                <img
                  src='/android.svg'
                  alt='Baixe o App PaGol na Play Store'
                  className='justify-self-center'
                />
              </SecondaryButton>
              <SecondaryButton
                onClick={() => {
                  onTrackEvent();
                  window.location.href =
                    'https://apps.apple.com/br/app/pagol/id1643147483';
                }}
                className={`
                flex-1
                h-[45px]
                w-auto
                m-0
                border-white
                rounded-[7px]
                justify-center
                align-center
                text-white
                font-inter
                font-normal
                text-base
                hidden

                hover:border-[#C1D8EA]
                hover:text-[#C1D8EA]

                sm:flex
                sm:justify-center
              `}
              >
                <img
                  src='/ios.svg'
                  alt='Baixe o App PaGol na App Store'
                  className='justify-self-center'
                />
              </SecondaryButton>
            </Box>
          </Box>
          <SecondaryButton
            onClick={() => {
              onTrackEvent();
              window.location.href = getUrlIOSorAndroid();
            }}
            className={`
            w-auto
            mt-8
            mb-10
            mx-6
            
            border-white
            text-white
            font-inter
            font-semibold
            text-base

            hover:border-[#C1D8EA]
            hover:text-[#C1D8EA]

            sm:mb-0
            sm:mx-0
            sm:h-12
            sm:mt-0
            sm:hidden
          `}
          >
            Baixe o App PaGol
          </SecondaryButton>
        </Box>
      </Box>
    </Box>
  );
};
